module.exports = __webpack_public_path__ + "img/icon-mamreq.65da24f0.png";